export default __webpack_public_path__ + "static/media/Rectangle_yellow_1.e3c53c10.svg";